"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoadCategories = void 0;
var react_1 = __importDefault(require("react"));
var customFetch_1 = require("../helpers/customFetch");
var useLoadCategories = function () {
    var _a = react_1.default.useState([]), brands = _a[0], setBrands = _a[1];
    var _b = react_1.default.useState([]), models = _b[0], setModels = _b[1];
    var _c = react_1.default.useState([]), generations = _c[0], setGenerations = _c[1];
    var _d = react_1.default.useState([]), colors = _d[0], setColors = _d[1];
    var _e = react_1.default.useState([]), bodyTypes = _e[0], setBodyTypes = _e[1];
    var _f = react_1.default.useState([]), enginePowerTypes = _f[0], setEnginePowerTypes = _f[1];
    var _g = react_1.default.useState([]), engineNameTypes = _g[0], setEngineNameTypes = _g[1];
    var _h = react_1.default.useState([]), engineCapacityTypes = _h[0], setEngineCapacityTypes = _h[1];
    var _j = react_1.default.useState([]), gearboxTypes = _j[0], setGearboxTypes = _j[1];
    var _k = react_1.default.useState([]), driveTypes = _k[0], setDriveTypes = _k[1];
    var _l = react_1.default.useState([]), extras = _l[0], setExtras = _l[1];
    var _m = react_1.default.useState([]), categories = _m[0], setCategories = _m[1];
    react_1.default.useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, brandsResponse, modelsResponse, generationsResponse, colorsResponse, bodyTypesResponse, enginePowerTypesResponse, engineNameTypesResponse, engineCapacityTypesResponse, gearboxTypesResponse, driveTypesResponse, extrasResponse, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _c = (_b = Promise).all;
                        return [4 /*yield*/, (0, customFetch_1.customFetch)({ url: 'brands', method: 'GET' })];
                    case 1:
                        _d = [
                            _e.sent()
                        ];
                        return [4 /*yield*/, (0, customFetch_1.customFetch)({ url: 'models', method: 'GET' })];
                    case 2:
                        _d = _d.concat([
                            _e.sent()
                        ]);
                        return [4 /*yield*/, (0, customFetch_1.customFetch)({ url: 'generations', method: 'GET' })];
                    case 3:
                        _d = _d.concat([
                            _e.sent()
                        ]);
                        return [4 /*yield*/, (0, customFetch_1.customFetch)({ url: 'colors', method: 'GET' })];
                    case 4:
                        _d = _d.concat([
                            _e.sent()
                        ]);
                        return [4 /*yield*/, (0, customFetch_1.customFetch)({ url: 'body_types', method: 'GET' })];
                    case 5:
                        _d = _d.concat([
                            _e.sent()
                        ]);
                        return [4 /*yield*/, (0, customFetch_1.customFetch)({ url: 'engine_power_types', method: 'GET' })];
                    case 6:
                        _d = _d.concat([
                            _e.sent()
                        ]);
                        return [4 /*yield*/, (0, customFetch_1.customFetch)({ url: 'engine_name_types', method: 'GET' })];
                    case 7:
                        _d = _d.concat([
                            _e.sent()
                        ]);
                        return [4 /*yield*/, (0, customFetch_1.customFetch)({ url: 'engine_capacity_types', method: 'GET' })];
                    case 8:
                        _d = _d.concat([
                            _e.sent()
                        ]);
                        return [4 /*yield*/, (0, customFetch_1.customFetch)({ url: 'gearbox_types', method: 'GET' })];
                    case 9:
                        _d = _d.concat([
                            _e.sent()
                        ]);
                        return [4 /*yield*/, (0, customFetch_1.customFetch)({ url: 'drive_types', method: 'GET' })];
                    case 10:
                        _d = _d.concat([
                            _e.sent()
                        ]);
                        return [4 /*yield*/, (0, customFetch_1.customFetch)({
                                url: 'extras/all_extras',
                                method: 'GET',
                            })];
                    case 11: return [4 /*yield*/, _c.apply(_b, [_d.concat([
                                _e.sent()
                            ])])];
                    case 12:
                        _a = _e.sent(), brandsResponse = _a[0], modelsResponse = _a[1], generationsResponse = _a[2], colorsResponse = _a[3], bodyTypesResponse = _a[4], enginePowerTypesResponse = _a[5], engineNameTypesResponse = _a[6], engineCapacityTypesResponse = _a[7], gearboxTypesResponse = _a[8], driveTypesResponse = _a[9], extrasResponse = _a[10];
                        setBrands(brandsResponse);
                        setModels(modelsResponse);
                        setGenerations(generationsResponse);
                        setColors(colorsResponse);
                        setBodyTypes(bodyTypesResponse);
                        setEnginePowerTypes(enginePowerTypesResponse);
                        setEngineNameTypes(engineNameTypesResponse);
                        setEngineCapacityTypes(engineCapacityTypesResponse);
                        setGearboxTypes(gearboxTypesResponse);
                        setDriveTypes(driveTypesResponse);
                        setExtras(extrasResponse.all_extra_names);
                        setCategories(extrasResponse.all_categories);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    var refreshData = react_1.default.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, brandsResponse, modelsResponse, generationsResponse, colorsResponse, bodyTypesResponse, enginePowerTypesResponse, engineNameTypesResponse, engineCapacityTypesResponse, gearboxTypesResponse, driveTypesResponse, extrasResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        (0, customFetch_1.customFetch)({ url: 'brands', method: 'GET' }),
                        (0, customFetch_1.customFetch)({ url: 'models', method: 'GET' }),
                        (0, customFetch_1.customFetch)({ url: 'generations', method: 'GET' }),
                        (0, customFetch_1.customFetch)({ url: 'colors', method: 'GET' }),
                        (0, customFetch_1.customFetch)({ url: 'body_types', method: 'GET' }),
                        (0, customFetch_1.customFetch)({ url: 'engine_power_types', method: 'GET' }),
                        (0, customFetch_1.customFetch)({ url: 'engine_name_types', method: 'GET' }),
                        (0, customFetch_1.customFetch)({ url: 'engine_capacity_types', method: 'GET' }),
                        (0, customFetch_1.customFetch)({ url: 'gearbox_types', method: 'GET' }),
                        (0, customFetch_1.customFetch)({ url: 'drive_types', method: 'GET' }),
                        (0, customFetch_1.customFetch)({
                            url: 'extras/all_extras',
                            method: 'GET',
                        }),
                    ])];
                case 1:
                    _a = _b.sent(), brandsResponse = _a[0], modelsResponse = _a[1], generationsResponse = _a[2], colorsResponse = _a[3], bodyTypesResponse = _a[4], enginePowerTypesResponse = _a[5], engineNameTypesResponse = _a[6], engineCapacityTypesResponse = _a[7], gearboxTypesResponse = _a[8], driveTypesResponse = _a[9], extrasResponse = _a[10];
                    setBrands(brandsResponse);
                    setModels(modelsResponse);
                    setGenerations(generationsResponse);
                    setColors(colorsResponse);
                    setBodyTypes(bodyTypesResponse);
                    setEnginePowerTypes(enginePowerTypesResponse);
                    setEngineNameTypes(engineNameTypesResponse);
                    setEngineCapacityTypes(engineCapacityTypesResponse);
                    setGearboxTypes(gearboxTypesResponse);
                    setDriveTypes(driveTypesResponse);
                    setExtras(extrasResponse.all_extra_names);
                    setCategories(extrasResponse.all_categories);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    return {
        brands: brands,
        models: models,
        generations: generations,
        colors: colors,
        bodyTypes: bodyTypes,
        enginePowerTypes: enginePowerTypes,
        engineNameTypes: engineNameTypes,
        engineCapacityTypes: engineCapacityTypes,
        gearboxTypes: gearboxTypes,
        driveTypes: driveTypes,
        extras: extras,
        categories: categories,
        refreshData: refreshData,
    };
};
exports.useLoadCategories = useLoadCategories;
